import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledPhrasesFilter = styled('div')(
  () => css`
    .phrases-filter {
      .selected-items {
        margin-top: 14px;
        display: flex;
        flex-wrap: wrap;

        .item {
          display: flex;
          align-items: center;
          background-color: #e1e8ff;
          border: 1px solid #e4e9ec;
          padding: 8px;
          border-radius: 6px;
          margin-left: 8px;
          margin-bottom: 0.5rem;
          color: #4c6fff;
          font-size: 0.75rem;
          font-weight: 400;
          line-height: 1.5rem;

          .item-icon {
            color: inherit;
            font-weight: 500;
            transition: all 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);

            &:hover {
              color: #002de5;
            }
          }

          &:last-of-type {
            margin-left: 0;
          }
        }
      }
    }
  `
);
